// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__HswBA","gitIcon":"styles_gitIcon__KVQCd","gitLink":"styles_gitLink__M73Yc"};